import { ReportGroupService } from 'src/app/features/admin/report-group/report-group.service';
import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { delay, finalize, take } from 'rxjs';
import { ModalConfig } from 'src/app/shared/components/modal/modal-config';
import { USER_MESSAGES } from 'src/app/util/constantes-mensajes';
import { ReportGroup } from '../../admin/report-group/report-group';
import { User } from '../user';
import { UserService } from '../user.service';
import { AuthService } from 'src/app/auth/auth.service';
@Component({
  selector: 'app-report-group-to-user',
  templateUrl: './report-group-to-user.component.html',
  styleUrls: ['./report-group-to-user.component.scss']
})
export class ReportGroupToUserComponent implements OnInit {
  // Selected user to add or remove report groups
  @Input() currentUser: User;
  // Form control to query users
  queryControl: FormControl;
  // Object with the selected report groups
  selectedReportGroups: ReportGroup[] = [];
  // Variable to set modal information
  public modalConfig: ModalConfig;
  // Base user url (se debe crear la variable pública en el servicio)
  reportGroupsUrl: string;
  // Handles the spinner status
  isLoading: boolean = false;
  // Contains X mark icon
  faCircleXmark = faCircleXmark;

  constructor(
    private userService: UserService,
    private reportGroupService: ReportGroupService,
    private ngbActiveModal: NgbActiveModal,
    private authService: AuthService
  ) {
    this.reportGroupsUrl = this.reportGroupService.reportGroupsUrl
  }

  ngOnInit(): void {
    this.modalConfig = {
      modalTitle: "Grupos de reportes usuario",
      ...this.modalConfig,
    };
    this.initQueryControl();
    this.getUserReportGroups();
  }

  /**
   * Initializes the query control to search users
   * @returns None
   */
  initQueryControl(): void {
    this.queryControl = new FormControl(null);
  }

  /**
   * This function returns the list of report groups of the current user
   */
  getUserReportGroups() {
    this.isLoading = true;
    this.userService.getReportGroups(this.currentUser.uuid)
      .pipe(
        take(1),
        delay(500),
        finalize(() => this.isLoading = false))
      .subscribe({
        next: (response: ReportGroup[]) => {
          this.selectedReportGroups = response;
        },
        error: (error) => {
          this.ngbActiveModal.close({ message: error.error.message, confirmTitle: "Cerrar", isError: true });
        }
      });
  }

  /**
   * This method inserts the selected report group in the list if it is not duplicated
   * @param {ReportGroup} reportGroup
   */
  addReportGroup(reportGroup: ReportGroup) {
    let isDuplicate = this.selectedReportGroups.find((search) => search.uuid === reportGroup.uuid);
    if (!isDuplicate)
      this.selectedReportGroups.push(reportGroup);
  }

  /**
   * This method associates all created report groups to the current user
   */
  addAllReportGroups() {
    this.reportGroupService.addAllReportGroupsToUser(this.currentUser.uuid)
      .subscribe({
        next: (response: ReportGroup[]) => {
          this.selectedReportGroups = response;
        },
        error: (error) => {
          this.ngbActiveModal.close({ message: error.error.message, confirmTitle: "Cerrar", isError: true });
        }
      });
  }

  /**
   * check if the actual role of the logged user is ADMIN
   * @returns {boolean}
   */
  checkAdminRole(): boolean{
    return this.authService.user!.rol === 'ADMIN';
  }

  /**
   * A function that removes the selected report group from the list
   * @param {ReportGroup} reportGroup
   * @returns None
   */
  removeReportGroup(reportGroup: ReportGroup): void {
    this.selectedReportGroups = this.selectedReportGroups.filter((element) => element.uuid !== reportGroup.uuid);
  }

  /**
   * Associates the list of selected report groups to the current user
   */
  saveReportGroupList() {
    this.isLoading = true;
    this.userService.setReportGroups(this.currentUser.uuid, this.selectedReportGroups)
      .pipe(
        finalize(() => this.isLoading = false))
      .subscribe({
        next: () => {
          this.ngbActiveModal.close({ message: USER_MESSAGES.UPDATE.USER, confirmTitle: "Aceptar" });
        },
        error: (error) => {
          this.ngbActiveModal.close({ message: error.error.message, confirmTitle: "Cerrar", isError: true });
        }
      });
  }
}